import { Component, Input } from '@angular/core';

@Component({
  selector: 'core-text-modal',
  templateUrl: './core-text-modal.component.html',
  styleUrls: ['./core-text-modal.component.scss']
})
export class CoreTextModalComponent {
  @Input() modalData!: string;
}
